export default "__VITE_ASSET__367cA9fF__"